import { useRouter } from "next/router";
import {
  createStyles,
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "next-i18next";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import SocialButtons from "./socialButtons";
import Breadcrumbs, { BreadcrumbsProps } from "./breadcrumbs";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadcrumbs: {
      marginBottom: theme.spacing(3),
    },
    message: {
      textAlign: "center",
      margin: theme.spacing(4),
    },
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    spacer: {
      marginTop: theme.spacing(6),
    },
  })
);

interface TitleBlockProps {
  title: string;
  subtitle: string;
  headerImage?: string;
  breadcrumb?: BreadcrumbsProps;
  disableSocialButtons?: boolean;
}

export default function TitleBlock(props: TitleBlockProps) {
  const { t: t_common } = useTranslation("common");
  const router = useRouter();
  const classes = useStyles();
  const theme = useTheme();

  const fullURL = "www.tokiyado.net/" + router.locale + router.asPath;

  return (
    <React.Fragment>
      {props.breadcrumb ? (
        <div className={classes.breadcrumbs}>
          <Breadcrumbs {...props.breadcrumb} />
        </div>
      ) : null}

      {router.locale === "en" ? (
        <div className={classes.message}>
          <Typography variant="body1" color="textSecondary">
            We are working on translations for this article...
          </Typography>
        </div>
      ) : null}
      <div className={classes.container}>
        <div>
          <Typography variant="h4" gutterBottom color="primary">
            {props.title}
          </Typography>

          <Typography variant="body1" gutterBottom>
            {props.subtitle}
          </Typography>
        </div>

        {!props.disableSocialButtons ? (
          <div>
            このページを共有する：
            <SocialButtons url={fullURL} image={props.headerImage} />
          </div>
        ) : null}
      </div>

      <Divider />
      <div className={classes.spacer}></div>
    </React.Fragment>
  );
}
